import styled from 'styled-components';
import type { VolumesView } from './systems';

const Group = styled.div`
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

const Option = styled.button<{ $active: boolean }>`
  border: none;
  padding: ${({ theme }) => theme.spacing(1.5)} ${({ theme }) => theme.spacing(3)};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: ${({ $active, theme }) => ($active ? '#fff' : theme.colors.text.primary)};
  background: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.backgroundElevated};

  & + & {
    border-left: 1px solid ${({ theme }) => theme.colors.border};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;

interface Props {
  view: VolumesView;
  onChange: (view: VolumesView) => void;
  /** В комплекте есть разметка систем (ОВ, ВК, НВ, НК после волны). */
  systems: boolean;
}

const OPTIONS: { view: VolumesView; title: string }[] = [
  { view: 'systems', title: 'По системам' },
  { view: 'summary', title: 'Сводно ▶' },
  { view: 'rows', title: 'Строки по порядку РД' },
];

/** Переключатель вида экрана «Объёмы»: «По системам» (система ▶ раздел ▶ строки;
 *  в комплектах без систем — «По группам»: вложенные уровни групп таблиц),
 *  «Сводно ▶» (ведомость материалов ▶ доли систем или групп), строки в порядке
 *  РД. */
export function ViewSwitch({ view, onChange, systems }: Props) {
  return (
    <Group role="group" aria-label="Вид списка позиций">
      {OPTIONS.map((o) => (
        <Option
          key={o.view}
          type="button"
          $active={view === o.view}
          aria-pressed={view === o.view}
          title={
            o.view === 'systems' && !systems
              ? 'В комплекте нет разметки систем — строки по заголовкам групп таблиц: элемент ▶ раздел ▶ строки'
              : undefined
          }
          onClick={() => onChange(o.view)}
        >
          {o.view === 'systems' && !systems ? 'По группам' : o.title}
        </Option>
      ))}
    </Group>
  );
}
